export class SubmissionReview {
    CommentToProducer: string;
}
